import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ObjectiveFlag } from '_components';
import { noteActions } from '_actions';
import { CheckBox } from './CheckBox';
import { RadioButton } from './RadioButton';
import styles from './DBCheckBoxRadioComment.module.css'


class DBCheckBoxRadioComment extends React.Component {

    handleClick() {
        if (!this.props.disabled === true) {
            if (this.props.value) {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field)
            } else {
                this.props.updateBitField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, !this.props.value)
            }
            if (this.props.onClick) {
                this.props.onClick(!this.props.value);
            }
        }
    }

    updateField(option) {
        const {
            clearField,
            updateIntField,
            updateBitField,
            updateTextField,
            onClick
        } = this.props;

        const {
            selected,
            noteId,
            entity,
            entityKeyColumn,
            entityKeyValue,
            field,
            selectedValue,
            type,
            showFlag = true
        } = option; 

        if (selected) {
            
            if(!showFlag){
                this.setState({
                    showFlag: true,
                });
            }
           
            clearField(noteId, entity, entityKeyColumn, entityKeyValue, field);
        } else {
            switch (type) {
                case 'int':
                    updateIntField(noteId, entity, entityKeyColumn, entityKeyValue, field, selectedValue);
                    break;
                case 'bit':
                    updateBitField(noteId, entity, entityKeyColumn, entityKeyValue, field, selectedValue);
                    break;
                default:
                    updateTextField(noteId, entity, entityKeyColumn, entityKeyValue, field, selectedValue);
                    break;
            }

            this.setState({
                showFlag: showFlag,
            });
            
        }

        if (onClick) {
            onClick(selected ? undefined : selectedValue);
        }
    }

    constructor() {
        super();
        this.state = {
            value: '',
            txtValue: '',
            changingTimeout: 0,
            hasChanges: false,
            showFlag: true,
        };
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.saveValue = this.saveValue.bind(this);
    }

    componentDidMount() {
        this.setState((state) => {
            return {
                value: this.props.value ? this.props.value : '',
                txtValue: this.props.txtValue ? this.props.txtValue : ''
            };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId !== prevProps.noteId ||
            this.props.entity !== prevProps.entity ||
            this.props.entityKeyValue !== prevProps.entityKeyValue ||
            this.props.field !== prevProps.field ||
            this.props.value !== prevProps.value) {
            this.setState((state) => {
                return {
                    value: this.props.value ? this.props.value : '',
                    hasChanges: false,
                    txtValue: this.props.txtValue ? this.props.txtValue : ''
                };
            })
        }
    }

    handleValueChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        this.setState({
            txtValue: event.target.value,
            hasChanges: true,
            changingTimeout: setTimeout(() => this.saveValue(), 2000)
        });
    }

    saveValue() {
        if (this.state.hasChanges) {
            this.state.txtValue.trim() === '' ?
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field + 'TXT')
                :
                this.props.updateTextField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field + 'TXT', this.state.txtValue);
            this.setState({ hasChanges: false });

            if (this.props.onChange) {
                this.props.onChange(this.state.txtValue);
            }
        }
    }

    handleOnBlur() {
        this.saveValue();
        clearTimeout(this.state.changingTimeout);
    }

    render() {
        return (
            <>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged && this.state.showFlag} flagText={this.props.label} />
                    <CheckBox
                        title={this.props.title}
                        size={this.props.size}
                        className={styles.check_box}
                        checked={this.props.value}
                        label={this.props.label}
                        disabled={this.props.disabled}
                        onClick={() => this.handleClick()}

                    />
                    {
                    Array.isArray(this.props.selectedOptions)
                    && 
                    this.props.selectedOptions?.map((option) => (
                    <div key={option.id} className={styles.radioButton} style={option?.style} >
                        <RadioButton              
                           size={option.size ?? 'small'}                
                           selected={option.selected}     
                           label={option.label}   
                           disabled={this.props.disabledOptions}
                           onClick={() => this.updateField(option)}
                        />   
                    </div>
                ))}
                </div>
                {this.props.value &&
                    <>
                        <br />
                        <textarea
                            className={this.props.textAreaStyle ? this.props.textAreaStyle : styles.textarea}
                            type="text"
                            title={this.props.title ? this.props.title : ''}
                            onChange={this.handleValueChange}
                            onBlur={this.handleOnBlur}
                            disabled={this.props.disabledTxt}
                            rows={this.props.rows ? this.props.rows : 3}
                            maxLength={this.props.maxLength ? this.props.maxLength : -1}
                            placeholder={this.props.placeholder}
                            value={this.state.txtValue} />
                        <br />
                    </>
                }
            </>
        );

    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    const options = ownprops.options || [];
    const selectedOptions = options.map(option => {
        const { entity, entityKeyValue, field, selectedValue } = option;
        const type = state.entities.masterData.PTERONOTESCHEMA[`${entity}.${field}`]?.DATA_TYPE;
        const isSelected = state.entities.notes[entity]?.[entityKeyValue]?.[field] === selectedValue;

        return {
            ...option, 
            selected: isSelected,
            type 
        };
    });
    return {
        flagged: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ? state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : false,
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ? state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : false,
        txtValue: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field + 'TXT'] !== null ? state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field + 'TXT'] : false,
        disabled: ownprops.disabled !== undefined ? ownprops.disabled : false,
        selectedOptions,
    };
}

const connectedRadioComment = connect(mapStateToProps, mapDispatchToProps)(DBCheckBoxRadioComment);
export { connectedRadioComment as DBCheckBoxRadioComment };